import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, lastValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CustomNavigationService } from '../custom-navigation.service';

/**
 * The purpose of this Guard is to handle refresh page logic. When the logged in
 * user refreshes a page in the app while being logged in, this guard gets the user
 * and other relevant initialization data.
 */
@Injectable({
  providedIn: 'root',
})
export class RefreshPageGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private customNavigationService: CustomNavigationService
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {


    if (localStorage.getItem('token')) {

      return lastValueFrom(this.authService.fetchProfile())
        .then((_) => true)
        .catch(( error: any) => {
          console.error(error);
          this.authService.clearStorage();
          this.customNavigationService.navigate(['main/login']);
          return false;
        });
    }

    return true;

  }
}
